<template>
  <div
    class="
      sf-dropdown2-item
      tw-bg-sf-snow-dark tw-text-sf-gray-light
      hover:tw-text-sf-gray-light
      tw-text-[11px] tw-uppercase tw-font-medium tw-text-xs
      !tw-cursor-default
      tw-py-2 tw-px-4
      sf-nowrap
    "
    data-testid="dropdown-item-header"
    v-bind="$attrs"
    @click.stop.prevent
  >
    <span class="tw-inline-flex tw-flex-1">
      <slot name="icon" />
      <slot name="default" />
    </span>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'SfDropdownItemHeader',
})
</script>
